﻿import $ from "jquery";

export function GetValuesArray(parentElement, selector) {
    const elements = parentElement.find(selector);
    const attributes = $.map(elements,
        function(list) {
            return [$(list).val()];
        });

    return attributes;
}

export function GetDataAttributesArray(parentElement, selector, dataAttribute) {
    const elements = parentElement.find(selector);
    const attributes = $.map(elements,
        function(list) {
            return [$(list).data(dataAttribute)];
        });

    return attributes;
}


//////////////////
// WEBPACK FOOTER
// ./Scripts/utils/formHelper.js
// module id = 1
// module chunks = 1